/** 로그인 이메일 비교: 앞뒤 공백·대소문자 무시 */
export function normalizeLoginEmail(raw: string): string {
  return raw.trim().toLowerCase();
}

export function loginEmailsMatch(input: string, actual: string): boolean {
  const a = normalizeLoginEmail(input);
  const b = normalizeLoginEmail(actual);
  return Boolean(a && b && a === b);
}

function maskEmailLocalPart(local: string): string {
  const n = local.length;
  if (n <= 0) return '';
  if (n === 1) return '*';
  if (n === 2) return `${local[0]}*`;
  if (n === 3) return `${local[0]}*${local[2]}`;
  return `${local.slice(0, 2)}${'*'.repeat(n - 3)}${local.slice(-1)}`;
}

/**
 * 잠금 해제 힌트: 아이디는 앞·뒤만 남기고 가리고, 도메인은 그대로 둔다.
 * 예: yangsongi@gmail.com → ya******i@gmail.com
 */
export function maskLoginEmailHint(email: string): string {
  const trimmed = email.trim();
  if (!trimmed) return '';
  const at = trimmed.lastIndexOf('@');
  if (at <= 0 || at === trimmed.length - 1) {
    return maskEmailLocalPart(trimmed) || '*';
  }
  const local = trimmed.slice(0, at);
  const domain = trimmed.slice(at);
  return `${maskEmailLocalPart(local)}${domain}`;
}

/**
 * 계정 메뉴·프로필 등에서 본인 이메일을 가릴 때.
 * 로컬 첫 글자만 남기고 나머지는 *, 도메인은 그대로.
 * 예: yangsongi@gmail.com → y*******@gmail.com
 */
export function maskEmailForDisplay(email: string): string {
  const trimmed = email.trim();
  if (!trimmed) return '';
  const at = trimmed.lastIndexOf('@');
  if (at <= 0 || at === trimmed.length - 1) {
    if (trimmed.length <= 1) return trimmed || '';
    return `${trimmed[0]}${'*'.repeat(trimmed.length - 1)}`;
  }
  const local = trimmed.slice(0, at);
  const domain = trimmed.slice(at);
  if (local.length <= 1) return `${local}${domain}`;
  return `${local[0]}${'*'.repeat(local.length - 1)}${domain}`;
}
